<template>
  <svg v-bind="$attrs" preserveAspectRatio="none" :viewBox="viewbox">
    <rect
      x="1"
      y="1"
      :width="width - 2"
      :height="height - 2"
      :rx="r"
      :ry="r"
      fill="none"
      class="
        stroke-zinc-400
        transition-colors
        group-hover:stroke-zinc-600
        group-focus:border-zinc-600
        fix-transiton-stroke-dashoffset
        duration-1000
        delay-inherited
      "
      :style="style"
    ></rect>
  </svg>
</template>

<script>
import inViewMixin from '../../mixins/in-view'

export default {
  name: 'RoundedRectangleStrokeAnimation',
  mixins: [inViewMixin],
  props: {
    r: Number,
  },
  data() {
    return {
      width: 10,
      height: 10,
    }
  },
  computed: {
    viewbox() {
      return `0 0 ${this.width} ${this.height}`
    },
    style() {
      const l =
        2 * (this.width - 2 - 2 * this.r + this.height - 2 - 2 * this.r) +
        2 * Math.PI * this.r
      const style = {
        strokeDasharray: l,
      }
      if (!this.inView) {
        style.strokeDasharray =  `0 ${l}`
        style.strokeDashoffset = 0.1 * l
      }
      return style
    },
  },
  mounted() {
    this.width = this.$el.clientWidth
    this.height = this.$el.clientHeight
  },
}
</script>